import { z } from "zod";
import { msg } from "@/utils/multilingual";

export const createHotelOwnerRegistrationSchema = (t = msg) =>
  z.object({
    firstName: z
      .string()
      .trim()
      .min(1, t("common.first_name_is_required"))
      .max(
        100,
        t("registration.registration_form.validation.firstName.maxLength")
      ),
    lastName: z
      .string()
      .trim()
      .min(1, t("common.last_name_is_required"))
      .max(
        100,
        t("registration.registration_form.validation.lastName.maxLength")
      ),
    email: z
      .string()
      .trim()
      .email(t("registration.registration_form.validation.email.invalid")),
    phone: z
      .string()
      .trim()
      .optional()
      .refine(
        (val) => {
          // Allow empty values
          if (!val || val.trim() === "") return true;
          // If provided, validate E.164 format: +[1-9][0-9]{7,14}
          // Must start with +, followed by country code (1-9), then 7-14 digits
          return /^\+[1-9]\d{7,14}$/.test(val);
        },
        {
          message: t(
            "registration.registration_form.validation.phone.invalid"
          ),
        }
      ),

    hotelName: z
      .string()
      .trim()
      .min(
        2,
        t("common.hotel_name_is_required")
      )
      .max(
        200,
        t("registration.registration_form.validation.hotelName.maxLength")
      ),
    hotelCity: z
      .string()
      .trim()
      .min(
        2,
        t("common.city_is_required")
      )
      .max(
        128,
        t("registration.registration_form.validation.hotelCity.maxLength")
      ),
    hotelCityCode: z.string().trim().min(1).max(128).optional().default(""),
    hotelCountry: z
      .string()
      .trim()
      .min(
        2,
        t("common.country_is_required")
      )
      .max(
        128,
        t("registration.registration_form.validation.hotelCountry.maxLength")
      ),
    hotelCountryCode: z.string().trim().min(1).max(10).optional().default(""),
    hotelState: z.string().trim().min(1).max(128).optional().default(""),
    hotelStateCode: z.string().trim().min(1).max(128).optional().default(""),

    website: z
      .union([
        z
          .string()
          .trim()
          .url(
            t("registration.registration_form.validation.website.invalid")
          ),
        z.literal(""),
      ])
      .optional()
      .default(""),
    message: z
      .string()
      .trim()
      .max(
        2000,
        t("registration.registration_form.validation.message.maxLength")
      )
      .optional()
      .default(""),
  });

/** @deprecated Use createHotelOwnerRegistrationSchema(t) instead */
export const HotelOwnerRegistrationCreateSchema =
  createHotelOwnerRegistrationSchema();

export const hotelOwnerRegistrationDefaultValues = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  hotelName: "",
  hotelCity: "",
  hotelCityCode: "",
  hotelCountry: "Saudi Arabia",
  hotelCountryCode: "SA",
  hotelState: "",
  hotelStateCode: "",
  website: "",
  message: "",
};
